import {
  useMigrationStatusContext,
  MigrationStatusValue,
} from "./MigrationStatusProvider";

export const useMigrationStatus = (): MigrationStatusValue =>
  useMigrationStatusContext();

export default useMigrationStatus;
